<template>
  <PreviewBase
    v-if="isActive"
  >
    <template #actions>
      <router-link
        :to="{ name: 'job-profile-hris-view', params: { id: profileUlid } }"
        target="_blank"
        class="sidebar-editor-link d-flex align-center ga-1 text-textBrand"
      >
        <span class="text-body-3">View Job Profile in Editor</span>
        <v-icon icon="$open-in-new" size="16" color="textBrand" />
      </router-link>
    </template>
    <div class="d-flex flex-column ga-4">
      <h2 class="text-h2">
        Comments
      </h2>
      <CommentsSidebar
        :key="profileUlid"
        :page-id="profileUlid"
        page-name="job-profile-hris-view"
        :page-title="pageTitle"
        :thread-url="profileEditorUrl"
        @comment-added="handleCommentAdded"
      />
    </div>
  </PreviewBase>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PreviewBase from '@/components/shared/PreviewBase.vue';
import { useTracking } from '@/stores/tracking/tracking';
import CommentsSidebar from './CommentsSidebar.vue';

const route = useRoute();
const router = useRouter();

const isActive = computed(() => (
  route.query.type === 'jobProfileComments'
  && Boolean(route.query.preview)
));

const profileUlid = computed(() => route.query.preview || '');

const pageTitle = computed(() => route.query.previewTitle || profileUlid.value);

const profileEditorUrl = computed(() => {
  if (!profileUlid.value) return '';

  const resolved = router.resolve({
    name: 'job-profile-hris-view',
    params: { id: profileUlid.value },
  });

  return `${window.location.origin}${resolved.href}`;
});

const handleCommentAdded = () => {
  useTracking().jaMatrixAddedComment({ section: '' });
};
</script>

<style scoped lang="less">
.sidebar-editor-link:hover {
  opacity: 0.8;
}
</style>
